import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import LatestFilms from "./components/LatestFilms";
import FeaturedTopics from "./components/FeaturedTopics";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
        <SectionHeading
          eyebrow="快速进入"
          title="选择你想看的类型"
          desc="从电影的长篇叙事到电视剧的多线群像，找到最适合此刻心情的伦理故事。"
        />
        <CategoryEntries />
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <SectionHeading
          eyebrow="最新上映"
          title="最新影视作品"
          desc="按上映年份整理的最新伦理题材作品，封面、年份与剧情标签一目了然。"
          action={
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-50 transition-colors whitespace-nowrap"
            >
              浏览全部分类
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <LatestFilms />
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
        <SectionHeading
          eyebrow="专题策划"
          title="精选影视专题"
          desc="围绕一个伦理命题集中推荐多部作品，让片单之间产生对话。"
          action={
            <Link
              to="/topic/marriage"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              查看全部专题
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <FeaturedTopics />
      </section>

      <SiteIntro />
    </div>
  );
}